
import Home from "./components/Home";
import Gurus from "./components/Gurus";
import Branches from "./components/Branches"
import Gallery from "./components/Gallery";
import Events from "./components/Events";
import Publications from "./components/Publications";
import GuruDetailPage from "./components/GuruDetailPage";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Ideals from "./components/Ideals";
import "./styles/App.css";



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ideals" element={<Ideals />} />
        <Route path="/gurus" element={<Gurus />} />
        <Route path="/gurus/:id" element={<GuruDetailPage />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/branches" element={<Branches />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/events" element={<Events />} />
      </Routes>
    </Router>
  );
}

export default App;
